import * as React from "react";
import { RouteChildrenProps } from "react-router-dom";
import { IMarginRouteParams } from "../../../types/components/margin/marginTypes";
import { AGetMarginFiles } from "../../../service/marginFiles/marginApiService";
import { marginQueryParams, EMarginScreenState } from "../marginConstants";
import MarginTable from "../marginTable/marginTable";
import DeviceContext from "../../../service/indentifyDevice";
import moment from "moment";

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/generic/layout/layoutDesk.scss");
	require("../../../../assets/scss/components/toc/marginFiles/marginDsk.scss");
} else if (DeviceContext().isTablet) {
	require("../../../../assets/scss/components/generic/layout/layoutTab.scss");
	require("../../../../assets/scss/components/toc/marginFiles/marginTab.scss");
} else {
	require("../../../../assets/scss/components/generic/layout/layoutMob.scss");
	require("../../../../assets/scss/components/toc/marginFiles/marginMob.scss");
}

export interface IMarginContainerProps {}

export interface IMarginContainerState {
	data?: any; // if unedfined, then api is not called yet
	currentRouteParam?: IMarginRouteParams;
}

class MarginContainer extends React.Component<IMarginContainerProps & RouteChildrenProps<IMarginRouteParams>, IMarginContainerState> {
	state: IMarginContainerState = { currentRouteParam: this.props.match?.params };

	getMarginFilesRes = (res: any) => {
		switch (this.props.match?.params.fileType) {
			case "intraday":
				if (this.props.match.params.subParam === "equity") {
					this.setState({ data: res.intradaydata });
				} else if (this.props.match.params.subParam === "fno") {
					this.setState({ data: res.FNOIntradayData });
				}
				break;
			case "collateral":
				this.setState({ data: res.collateraldata });
				break;
			case "coverorder":
				this.setState({ data: res.CoverOrderData });
				break;
			case "fno":
				this.setState({
					data: res.fnoMargindata.map((row: any) => ({
						...row,
						trdSym: row.Symbol + moment(new Date(row.ExpDate)).format("YYMMM").toUpperCase() + "FUT"
					}))
				});
				break;
			case "currency":
				this.setState({
					data: res.currenydata.map((row: any) => ({
						...row,
						trdSym: row.InstrType + " " + row.Symbol + moment(new Date(row.ExpDate)).format("DD-MMM-YY")
					}))
				});
				break;
			case "mcx":
				if (this.props.match.params.subParam === "buy") {
					this.setState({
						data: res.mcxbuydata.map((row: any) => ({
							...row,
							trdSym: row.Symbol + moment(new Date(row.ExpDate)).format("YYMMM").toUpperCase() + "FUT"
						}))
					});
				} else if (this.props.match.params.subParam === "sell") {
					this.setState({
						data: res.mcxsellData.map((row: any) => ({
							...row,
							trdSym: row.Symbol + moment(new Date(row.ExpDate)).format("YYMMM").toUpperCase() + "FUT"
						}))
					});
				}
				break;
			case "ncdex":
				if (this.props.match.params.subParam === "buy") {
					this.setState({
						data: res.ncdxbuydata.map((row: any) => ({
							...row,
							trdSym: row.Symbol + moment(new Date(row.ExpDate)).format("YYMMM").toUpperCase() + "FUT"
						}))
					});
				} else if (this.props.match.params.subParam === "sell") {
					this.setState({
						data: res.ncdxselldata.map((row: any) => ({
							...row,
							trdSym: row.Symbol + moment(new Date(row.ExpDate)).format("YYMMM").toUpperCase() + "FUT"
						}))
					});
				}
				break;
			case "mtf":
				this.setState({ data: res.mtfdata });
		}
	};

	callApi() {
		const { fileType, subParam } = this.props.match?.params!;

		if (fileType) {
			if (fileType === "intraday") {
				if (subParam === "equity") {
					AGetMarginFiles(this.getMarginFilesRes, marginQueryParams.intraday);
				} else if (subParam === "fno") {
					AGetMarginFiles(this.getMarginFilesRes, marginQueryParams.fnointraday);
				}
			} else {
				AGetMarginFiles(this.getMarginFilesRes, marginQueryParams[fileType]);
			}
		}
	}

	componentDidMount() {
		// call the api initially
		this.setState({ currentRouteParam: this.props.match?.params });
		this.callApi();
	}

	componentDidUpdate() {
		// call api only if route is changed
		if (this.props.match?.params !== this.state.currentRouteParam) {
			this.setState({ currentRouteParam: this.props.match?.params, data: undefined });
			this.callApi();
		}
	}

	render() {
		return (
			<MarginTable data={this.state.data || []} screenState={this.state.data ? EMarginScreenState.DATA : EMarginScreenState.LOADING} />
		);
	}
}

export default MarginContainer;
